import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { UserService } from '../services/user.service';

export const operatorOkGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const blockedUrl = router.createUrlTree(['/operario-no-configurado']);

  return userService.checkOperatorOk().pipe(
    map(isOperatorOk => isOperatorOk ? true : blockedUrl),
    catchError(() => of(blockedUrl))
  );
};
